import React, { useRef, useEffect } from 'react';
import { LOGO_URL, LOGO_ALT } from '../config/constants';

/**
 * Loader component with split-screen door animation.
 * Uses GSAP when available, falls back to CSS transitions.
 */
const Loader = ({ onComplete }) => {
  const loaderRef = useRef(null);

  useEffect(() => {
    const loader = loaderRef.current;
    if (!loader) return;

    const initGSAPLoader = async () => {
      try {
        const gsapModule = await import('gsap');
        const gsap = gsapModule.default || gsapModule.gsap;

        gsap.set('.loader-content', { opacity: 0, scale: 0.95 });

        const tl = gsap.timeline({
          onComplete: () => {
            if (onComplete) onComplete();
            loader.style.display = 'none';
          },
        });

        tl.to('.loader-content', { opacity: 1, scale: 1, duration: 1, ease: 'power3.out', delay: 0.2 })
          .to('.loader-content', { opacity: 0, scale: 1.05, duration: 0.6, ease: 'power2.in', delay: 0.8 })
          .to('.loader-panel--left', { xPercent: -100, duration: 1, ease: 'power4.inOut' }, 'doors')
          .to('.loader-panel--right', { xPercent: 100, duration: 1, ease: 'power4.inOut' }, 'doors');
      } catch (e) {
        // Fallback: just hide after a delay
        setTimeout(() => {
          if (onComplete) onComplete();
          loader.style.display = 'none';
        }, 2500);
      }
    };

    initGSAPLoader();
  }, [onComplete]);

  return (
    <div className="loader" ref={loaderRef}>
      <div className="loader-panel loader-panel--left"></div>
      <div className="loader-panel loader-panel--right"></div>
      <div className="loader-content">
        <img src={LOGO_URL} alt={LOGO_ALT} className="loader-logo-img" />
      </div>
    </div>
  );
};

export default Loader;
